/**
 * Login Overlay logic
 * Gestisce l'apertura/chiusura dell'overlay e il login con Shop Pay
 */

class LoginOverlay {
  constructor() {
    this.overlay = document.getElementById('login-overlay');
    if (!this.overlay) return;

    this.closeButton = this.overlay.querySelector('[data-login-overlay="close"]');
    this.backdrop = document.getElementById('backdrop-darker');
    this.shopPayButton = document.getElementById('shop-pay-login');

    this.init();
  }

  init() {
    // Close button
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.closeOverlay());
    }

    // Backdrop click
    if (this.backdrop) {
      this.backdrop.addEventListener('click', () => this.closeOverlay());
    }


    // Listener per aprire l'overlay (es. da un bottone nel tema)
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-login-overlay-trigger]')) {
        e.preventDefault();
        this.openOverlay();
      }
    });
  }

  openOverlay() {
    this.overlay.classList.add('active');
    if (this.backdrop) {
      this.backdrop.classList.add('active');
      this.backdrop.style.zIndex = '55';
      document.body.style.overflow = 'hidden';
    }
  }

  closeOverlay() {
    this.overlay.classList.remove('active');
    if (this.backdrop) {
      this.backdrop.classList.remove('active');
      document.body.style.overflow = '';
      this.backdrop.style.zIndex = '';
    }
  }


}

new LoginOverlay();
